// extracted by mini-css-extract-plugin
export var iframe = "videoiframe-module--iframe--2cd8d";
export var videoPlayerContainer = "videoiframe-module--videoPlayerContainer--4c5f1";